import Container from "Components/Container/Container";
import React from "react";
import { useTranslation } from "react-i18next";
import LogoFooter from "./LogoFooter/LogoFooter";
import Navigation from "./Navigation/Navigation";
import Contact from "./Contact/Contact";
import Services from "./Services/Services";
const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-black">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 py-16">
          <LogoFooter />
          <Navigation />
          <Services />
          <Contact />
        </div>
      </Container>
      <div className="py-6 bg-[#121212] ">
        <Container>
          <div className="flex flex-col sm:flex-row sm:items-center justify-between text-white">
            <p>{t("All_Rights_Reserved")}</p>

            {/* <span>
              {t("By")}{" "}
              <a
                href="http://www.brandraw.sa"
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                {t("Dow_Group")}
              </a>
            </span> */}
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
